import { accent } from '@/components/feature/solution/theme';

interface TwinNode {
  icon: string;
  label: string;
}

interface AgriHeroData {
  eyebrow: string;
  title: string;
  desc: string;
  primaryLabel: string;
  secondaryLabel: string;
  image: string;
  alt: string;
  tags: string[];
  twinTitle: string;
  twinDesc: string;
  twinFlow: TwinNode[];
}

interface AgriHeroProps {
  data: AgriHeroData;
}

export default function AgriHero({ data }: AgriHeroProps) {
  const a = accent('green');

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img src={data.image} alt={data.alt} title={data.alt} className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/50"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-transparent to-foreground-950/70"></div>
      </div>

      <div className="absolute -top-20 -left-20 w-72 h-72 md:w-96 md:h-96 rounded-full bg-accent-500/20 blur-3xl animate-float-slow pointer-events-none"></div>
      <div
        className="absolute bottom-0 right-0 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-primary-500/15 blur-3xl animate-float-slow pointer-events-none"
        style={{ animationDelay: '2s' }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-16 md:pt-36 md:pb-20 flex items-center">
        <div className="max-w-[1200px] mx-auto w-full">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
            <span className={`w-2 h-2 rounded-full ${a.dot}`}></span>
            <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
              {data.eyebrow}
            </span>
          </div>

          <h1 className="mt-6 font-heading font-bold text-background-50 text-3xl md:text-5xl leading-tight">
            {data.title}
          </h1>

          <p className="mt-5 text-sm md:text-base text-foreground-200 leading-relaxed max-w-2xl">{data.desc}</p>

          <div className="mt-8 flex flex-wrap gap-2">
            {data.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/15 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}